//noScroll
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){


    const topBesideScroll = document.querySelector('.p-top__wrapper');
    const topBesideScroll02 = document.querySelector('.p-top__wrapper02');
    const body = document.querySelector("body")
    const topBesideEndPoint = document.querySelector(".js-endPoint").getBoundingClientRect().left
    const appearManPoint = document.querySelector(".js-FixedManStartPoint").getBoundingClientRect().right
    const disappearManPoint = document.querySelector(".js-FixedManEndPoint").getBoundingClientRect().right
    const storyFirstPoint = document.querySelector(".p-top__concept").getBoundingClientRect().right

    $(function(){
        /****************************
          横スクロール
         ****************************/
        if (window.matchMedia('(min-width: 768px)').matches) {
          /* ウィンドウサイズ669以上、767以下の処理を記述 */
          if(topBesideScroll) {
              gsap.registerPlugin(ScrollTrigger);
              const besideContents = gsap.utils.toArray('.js-besideContent');
              /**
              * 横スクロール開始
              */
              gsap.to( besideContents, {
                  x: -1 * (topBesideEndPoint) , // transformX
                  ease: "none", // easingの設定
                  scrollTrigger: { // scrollTrigger
                      trigger: topBesideScroll, // アニメーションの対象となる要素
                      pin: true, // 要素を固定する
                      scrub: 1, // スクロールとアニメーションを同期させる。数値で秒数の設定に
                      end: () => "+=" + topBesideEndPoint, // アニメーションの終了タイミング
                      invalidateOnRefresh: true,
                  }
              })
          }

          /****************************
          男性出現
          ****************************/
          if(topBesideScroll02) {
              gsap.registerPlugin(ScrollTrigger);
              const besideContents = gsap.utils.toArray('.js-besideContent02');
              /**
              * 横スクロール開始
              */
              gsap.to( besideContents, {
                  x: 1 * (disappearManPoint - appearManPoint) ,
                  ease: "none",
                  scrollTrigger: {
                      trigger: topBesideScroll02,
                      scrub: 1,
                      start: appearManPoint,
                      end:  disappearManPoint,
                      invalidateOnRefresh: true,

                  }
              })
          }

          const isHiddenFixedMan = document.querySelector(".js-besideContent02__inner")

          window.addEventListener("scroll", () => {


            if( window.scrollY > disappearManPoint){
              isHiddenFixedMan.classList.add("is-hidden")
            }else{
              isHiddenFixedMan.classList.remove("is-hidden")
            }
          })

          /****************************
          スクロール数パーセント表示
          ****************************/
          const percentBorder= document.querySelector(".js-scrollBorder")
          window.addEventListener("scroll", () => {
            let scrollY = window.scrollY;

            let scrollPercent = Math.floor(scrollY / topBesideEndPoint * 100);

            if(scrollY === 0){
              percentBorder.style.width = "0vw"
            }else{
              percentBorder.style.width = `${scrollPercent + 1}vw`
            }

          })

          /****************************
          フッター表示
          ****************************/
          const footer = document.querySelector(".footer-top")

          window.addEventListener("scroll", () => {
            let scrollY = window.scrollY;

            if(scrollY >= topBesideEndPoint - 1){
              footer.classList.add("is-active")
            }else{
              footer.classList.remove("is-active")
            }
          })


          /****************************
          ストーリーホバーアニメーション
          ****************************/
            const hovItems = document.querySelectorAll(".life-content")
            const handsdownMan = document.querySelector(".hands-down")
            const handsupMan = document.querySelector(".hands-up")
            const fixedManComment = document.querySelector(".js-fixedmanComment")
            const fixedManCommentText = document.querySelector(".js-fixedmanCommentText")
            hovItems.forEach((hovItem,i) => {
              const hovText = hovItem.querySelector(".js-point-hov");
              hovItem.addEventListener("mouseover", () => {
                handsdownMan.classList.add("is-hidden")
                handsupMan.classList.remove("is-hidden")

                switch (i){
                  case 0:
                    fixedManCommentText.innerHTML = "子どもに向けた金融教育についてお話します。"
                    break;
                  case 1:
                    fixedManCommentText.innerHTML = "中高生に向けた金融教育についてお話します。"
                    break;
                  case 2:
                    fixedManCommentText.innerHTML = "新社会人に向けたライフプランについてお話します。"
                    break;
                  case 3:
                    fixedManCommentText.innerHTML = "おふたりに合わせたライフプランについてお話します。"
                    break;
                  case 4:
                    fixedManCommentText.innerHTML = "お子様のご誕生に合わせたライフプランについてお話します。"
                    break;
                  case 5:
                    fixedManCommentText.innerHTML = "マイホーム購入に必要な資金計画についてお話します。"
                    break;
                  case 6:
                    fixedManCommentText.innerHTML = "社員向けの金融セミナーについてお話します。"
                    break;
                  case 7:
                    fixedManCommentText.innerHTML = "老後に向けた準備についてお話します。"
                    break;
                  case 8:
                    fixedManCommentText.innerHTML = "資産の継承についてお話します。"
                    break;
                  default:
                    console.log('error');
                }

                fixedManComment.classList.remove("is-hidden")
                hovText.textContent = "CHECK"


              })
              hovItem.addEventListener("mouseleave", () => {
                handsdownMan.classList.remove("is-hidden")
                handsupMan.classList.add("is-hidden")
                fixedManComment.classList.add("is-hidden")
              })
            })
      }})


      $(function(){
        if (window.matchMedia('(max-width: 767px)').matches) {
          /****************************
          SP storyスライダー
          ****************************/
          const swiper = new Swiper(".story-swiper", {
            slidesPerView: 1,
            spaceBetween: 50,
            speed: 800,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            pagination: {
              el: ".swiper-pagination",
              type: "fraction",
            },
            allowTouchMove: false,

          });


          /****************************
          SP 吹き出しテキスト調整
          ****************************/
          const commentSP = document.querySelector(".js-sp-comment")
          const target = document.querySelector(".js-slide-itemWrap")
          const targetChildren = document.querySelector(".js-slide-itemWrap").children

          const options = {
            childList: true, //直接の子の変更を監視
            characterData: true,　 //文字の変化を監視
            characterDataOldValue: true,　//属性の変化前を記録
            attributes: true,　 //属性の変化を監視
            subtree: true, //全ての子要素を監視
        }
          const eachItems = () => {

            switch (true){
              case targetChildren[0].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "子どもに向けた金融教育についてお話します。"
                break;
              case targetChildren[1].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "中高生に向けた金融教育についてお話します。"
                break;
              case targetChildren[2].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "新社会人に向けたライフプランについてお話します。"
                break;
              case targetChildren[3].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "おふたりに合わせたライフプランについてお話します。"
                break;
              case targetChildren[4].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "お子様のご誕生に合わせたライフプランについてお話します。"
                break;
              case targetChildren[5].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "マイホーム購入に必要な資金計画についてお話します。"
                break;
              case targetChildren[6].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "社員向けの金融セミナーについてお話します。"
                break;
              case targetChildren[7].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "老後に向けた準備についてお話します。"
                break;
              case targetChildren[8].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "資産の継承についてお話します。"
                break;
              default:
                console.log('error');
            }


          }
          const obs = new MutationObserver(eachItems);
          obs.observe(target, options);
        }
      })
  }
}
